import { render, staticRenderFns } from "./ResultPatientsPanel.vue?vue&type=template&id=3eccc689&scoped=true&"
import script from "./ResultPatientsPanel.vue?vue&type=script&lang=js&"
export * from "./ResultPatientsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ResultPatientsPanel.vue?vue&type=style&index=0&id=3eccc689&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eccc689",
  null
  
)

export default component.exports